import actionTypes from '../constants/actionTypes/error-action-types';

const initialState = {
    message: undefined
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET:
            return { message: action.payload };

        case actionTypes.CLEAN:
            return initialState;

        default:
            return state;
    }
};

export default reducer;
